// Mirrors back-end NotificationTypeEnum
// (back-end/itam-service/src/main/java/com/erpboi/itamservice/notification/NotificationTypeEnum.java)
// — keep in sync.

export const NOTIF_TYPE_LABEL: {[key: string]: string} = {
  WARRANTY_EXPIRY: 'Warranty Expiry',
  LICENSE_EXPIRY: 'License Expiry',
  LOW_STOCK: 'Low Stock',
  REPAIR_STATUS: 'Repair Status',
}

export const NOTIF_TYPE_TONE: {[key: string]: string} = {
  WARRANTY_EXPIRY: 'warning',
  LICENSE_EXPIRY: 'warning',
  LOW_STOCK: 'danger',
  REPAIR_STATUS: 'primary',
}

export const NOTIF_TYPE_ICON: {[key: string]: string} = {
  WARRANTY_EXPIRY: 'event_busy',
  LICENSE_EXPIRY: 'vpn_key',
  LOW_STOCK: 'production_quantity_limits',
  REPAIR_STATUS: 'build',
}

export const NOTIF_TYPE_OPTIONS = [
  {id: 'WARRANTY_EXPIRY', title: 'Warranty Expiry'},
  {id: 'LICENSE_EXPIRY', title: 'License Expiry'},
  {id: 'LOW_STOCK', title: 'Low Stock'},
  {id: 'REPAIR_STATUS', title: 'Repair Status'},
]
